import React from 'react';
import { colors } from '../constants/colors';
import { Text } from '@zopauk/react-components';
import { typography } from '../constants/typography';
import { InputTheme } from '@zopauk/react-components/types/components/styles/Theme';

export const input: InputTheme = {
  checkBox: {
    borderColorByStatus: {
      default: colors.jlMoneyGreyDark,
      error: colors.jlMoneyGreyDark,
      valid: colors.jlMoneyGreyDark,
      disabled: colors.jlMoneyGrey,
    },
    checkboxBackgroundColor: {
      disabled: colors.jlMoneyGreyLightest,
      checked: colors.jlMoneyGreenNeon,
      hover: colors.jlMoneyGreyDark,
    },
    label: {
      backgroundColor: colors.white,
      borderRadius: '0',
    },
    checked: {
      boxShadow: `0 0 0 1px`,
    },
    defaultColor: colors.jlMoneyGreyDark,
    borderRadius: '0',
    customIcon: true,
  },
  searchInput: {
    options: {
      hover: {
        backgroundColor: colors.jlMoneyGreyLightest,
        color: colors.jlMoneyGreyDark,
      },
      borderRadius: '0',
    },
    boxShadow: `0 0 0 1px ${colors.black}`,
    endIconColor: colors.jlMoneyGrey,
    border: '1px solid black',
    borderColor: colors.black,
    borderRadius: '0',
    customIcon: true,
  },
  borderColorByStatus: {
    valid: colors.jlMoneyGreyDark,
    disabled: colors.jlMoneyGrey,
    default: colors.jlMoneyGrey,
    error: colors.jlMoneyRed,
  },
  hover: {
    backgroundColor: colors.jlMoneyGreenLight,
    border: colors.jlMoneyGrey,
    error: colors.jlMoneyRed,
    boxShadow: `0 0 0 1px`,
  },
  disabled: {
    backgroundColor: colors.white,
    color: colors.jlMoneyGrey,
  },
  labelFontWeight: typography.weights.regular,
  labelLineHeight: typography.lineHeight.body,
  fontLineHeight: typography.lineHeight.body,
  placeholderColor: colors.jlMoneyGrey,
  boxShadow: `0 0 0 1px transparent`,
  startIconColor: colors.jlMoneyGrey,
  iconBackgroundColor: 'transparent',
  color: colors.jlMoneyGreenDark,
  startIconPaddingLeft: '20px',
  endIconPaddingRight: '60px',
  startIcon: <Text>£</Text>,
  borderRadius: `2px`,
  iconWidth: '24px',
  padding: '0 8px',
};
